import { render, staticRenderFns } from "./MedicalHistoryPhase.vue?vue&type=template&id=1d7b1846&scoped=true&"
import script from "./MedicalHistoryPhase.vue?vue&type=script&lang=js&"
export * from "./MedicalHistoryPhase.vue?vue&type=script&lang=js&"
import style0 from "./MedicalHistoryPhase.vue?vue&type=style&index=0&id=1d7b1846&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7b1846",
  null
  
)

export default component.exports